import React from 'react';

import * as commons from '../commons';
import FormLabel from "./FormLabel";

class FormLableClaimAmmounts extends  React.Component {

  render() {

    const {
      fields,
    } = this.props

    return (

      <div>

        {fields && fields.map((row, index) => {
          return (
            <div className="row" key={index}>
              <div className="col-4">
                <FormLabel
                    title='請求金額'
                    value={commons.dispMoney(row.claimAmmount)}
                />
              </div>
              <div className="col-4">
                <FormLabel
                    title='備考'
                    value={row.claimComment}
                />
              </div>
            </div>
          )
        })}

      </div>

    )

  }

}

export default FormLableClaimAmmounts


// WEBPACK FOOTER //
// ./src/components/FormLabelClaimAmmounts.js